var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoNaviNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18C36 27.9411 27.9411 36 18 36Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18C0.5 27.665 8.33502 35.5 18 35.5C27.665 35.5 35.5 27.665 35.5 18C35.5 8.33502 27.665 0.5 18 0.5C8.33502 0.5 0.5 8.33502 0.5 18Z",
    stroke: "#CCCCCC",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7772 18.15L16.0136 14.0669C15.6621 13.7656 15.6621 13.2772 16.0136 12.9759C16.3651 12.6747 16.9349 12.6747 17.2864 12.9759L22.6864 17.6045C23.0379 17.9058 23.0379 18.3942 22.6864 18.6955L17.2864 23.3241C16.9349 23.6253 16.3651 23.6253 16.0136 23.3241C15.6621 23.0228 15.6621 22.5344 16.0136 22.2331L20.7772 18.15Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_81_2343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 12,
    width: 8,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7772 18.15L16.0136 14.0669C15.6621 13.7656 15.6621 13.2772 16.0136 12.9759C16.3651 12.6747 16.9349 12.6747 17.2864 12.9759L22.6864 17.6045C23.0379 17.9058 23.0379 18.3942 22.6864 18.6955L17.2864 23.3241C16.9349 23.6253 16.3651 23.6253 16.0136 23.3241C15.6621 23.0228 15.6621 22.5344 16.0136 22.2331L20.7772 18.15Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_81_2343)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNaviNext);
export default __webpack_public_path__ + "static/media/ico-navi-next.a0b97049cf2e94c4649866c34df549cb.svg";
export { ForwardRef as ReactComponent };